import axios from 'axios';
import { UNKNOWN_ERROR } from '../../../../helpers/Constants';

const fetchCommentsService = async (sourceType, sourceId) => {
  try {
    return await axios.get(`/api/${sourceType}/${sourceId}/comment`);
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? UNKNOWN_ERROR);
  }
};

// eslint-disable-next-line import/prefer-default-export
export { fetchCommentsService };
